import ListingVM from './listing-vm';
import Vue from 'vue';
import 'libs/vue-extensions';
export default {
  init: function(element) {
    console.log('CourseworkListView initialization function called');
    let vm = new Vue(ListingVM);
    vm.bindData(JSON.parse(element.dataset.courseworkListingJson), JSON.parse(element.dataset.courseJson), JSON.parse(element.dataset.userPreferencesJson));
    vm.$mount(element);
  }
};

